import React from "react";
import * as SelectPrimitive from "@/components/ui/select";

const { Select: RSelect, SelectContent, SelectItem, SelectTrigger, SelectValue } = SelectPrimitive as any;

export interface SelectOption {
  value: string;
  label: string;
}

export function Select({
  value,
  onChange,
  options,
  placeholder = "Select…",
  className,
  testid,
}: {
  value?: string;
  onChange: (v: string) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  testid?: string;
}) {
  return (
    <RSelect value={value} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </RSelect>
  );
}
